import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, StoreState } from "../../redux/store";
import { getUserInfos } from "../../redux/users/usersSlice";

const useFetchUserInfos = (includePrivateInfos: boolean = false) => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentUser, loading, error } = useSelector((state: StoreState) => state.users);
  const shouldFetch = useRef(true);

  useEffect(() => {
    if ((!currentUser || (includePrivateInfos && !currentUser.infos.privateInfos)) && shouldFetch.current) {
      shouldFetch.current = false;
      dispatch(getUserInfos(includePrivateInfos));
    }
  }, [currentUser, dispatch, includePrivateInfos, loading]);

  return { loading, currentUser, error };
};

export default useFetchUserInfos;
